import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TierContext = createContext();

export const TierProvider = ({ children }) => {
  const { token } = useAuth();
  const [tier, setTier] = useState('standard');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) fetchProfile();
    else { setTier('standard'); setLoading(false); }
  }, [token]);

  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${API}/auth/profile`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTier(res.data.tier || 'standard');
    } catch {
      setTier('standard');
    } finally {
      setLoading(false);
    }
  };

  const TIER_HIERARCHY = { free: 0, standard: 1, premium: 2, platinum: 3 };
  const hasAccess = (requiredTier) => {
    return (TIER_HIERARCHY[tier] || 0) >= (TIER_HIERARCHY[requiredTier] || 0);
  };

  return (
    <TierContext.Provider value={{ tier, loading, hasAccess, refreshTier: fetchProfile }}>
      {children}
    </TierContext.Provider>
  );
};

export const useTier = () => {
  const ctx = useContext(TierContext);
  if (!ctx) throw new Error('useTier must be used within TierProvider');
  return ctx;
};
